(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/emp-video-player/assets/javascripts/helpers/setup-header.js') >= 0) return;  svs.modules.push('/components/components/emp-video-player/assets/javascripts/helpers/setup-header.js');
'use strict';

var registerHeaderComponents = function registerHeaderComponents() {
  var Button = empPlayer.videojs.getComponent('Button');
  var Component = empPlayer.videojs.getComponent('Component');
  var HeaderButton = empPlayer.videojs.extend(Button, {
    constructor: function constructor(player, options) {
      Button.apply(this, arguments);
      var headerButton = options.headerButton;
      this.customOnClick = headerButton.customOnClick;
      this.addClass('icon');
      this.addClass(headerButton.icon);
      this.controlText(headerButton.controlText);
      if (headerButton.customClass) {
        this.addClass(headerButton.customClass);
      }
    },
    handleClick: function handleClick() {
      this.customOnClick();
    }
  });
  var TitleBar = empPlayer.videojs.extend(Component, {
    constructor: function constructor(player, options) {
      Component.apply(this, arguments);

      if (options.text) {
        this.updateTextContent(options.text);
      }
    },
    createEl: function createEl() {
      return empPlayer.videojs.dom.createEl('div', {
        className: 'vjs-title-bar'
      });
    },
    updateTextContent: function updateTextContent(text) {
      if (typeof text !== 'string') {
        text = ' ';
      }
      empPlayer.videojs.dom.emptyEl(this.el());
      empPlayer.videojs.dom.appendContent(this.el(), text);
    }
  });
  empPlayer.videojs.registerComponent('TitleBar', TitleBar);
  empPlayer.videojs.registerComponent('HeaderButton', HeaderButton);
};
var setupHeader = function setupHeader(options) {
  var player = options.player;

  player.removeChild('TitleBar');
  player.removeChild('HeaderButton');
  if (options.headerButton) {
    player.addChild('HeaderButton', {
      headerButton: options.headerButton
    });
  }
  if (options.headerInfo) {
    player.addChild('TitleBar', {
      text: options.headerInfo
    });
  }
};
svs.components.emp_video_player.helpers.setupHeader = {
  setupHeader: setupHeader,
  registerHeaderComponents: registerHeaderComponents
};

 })(window);